import React, { Component } from "react";
import { ExperimentalSetupPosterIcon } from '@learningblocks/storybook-components/lib/Icons';

export class ExperimentalSetupPoster extends Component {

  doneClicked =()=>{
    this.props.showModal({
      display: false
    })
  }

  render() {

    return (
      <div className="modal-section" style={{ margin: 0, padding: 0 }}>
        <img src={ExperimentalSetupPosterIcon} alt={ this.props.altText } />
      </div>

    );
  }
}
